import { createSlice } from '@reduxjs/toolkit';
import { getJobParameters } from 'ducks/job-parameters/operators';
import { Slices } from 'ducks/slices';
import { ProjectParameters } from 'ducks/types/store-types';
import { normalizeParameters } from 'ducks/utils';

const initialState: ProjectParameters = [];

const jobParametersSlice = createSlice({
  name: Slices.JOB_PARAMETERS,
  initialState,
  reducers: {
    clearParameters: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getJobParameters.pending, () => {
        return initialState;
      })
      .addCase(getJobParameters.fulfilled, (_, { payload }) => {
        return normalizeParameters(payload);
      })
      .addCase(getJobParameters.rejected, () => {
        return initialState;
      });
  },
});

export const { clearParameters } = jobParametersSlice.actions;

export default jobParametersSlice.reducer;
